module.exports = __webpack_public_path__ + "media/video4.cbb63ff6.mp4";